document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".tabbed-new-products").forEach((root) => {

    const tabsWrap = root.querySelector(".tnp-tabs-wrap");
    const tabsEl = root.querySelector(".tnp-tabs");
    const tabs = Array.from(root.querySelectorAll(".tnp-tab"));
    const panels = Array.from(root.querySelectorAll(".tnp-panel"));
    const btnPrev = root.querySelector(".tnp-nav--prev");
    const btnNext = root.querySelector(".tnp-nav--next");

    if (!tabsEl || tabs.length === 0 || panels.length === 0) return;

    const columnsSetting = root.getAttribute("data-columns-desktop");
    const columns = columnsSetting ? Number(columnsSetting) : 4;
    root.style.setProperty("--tnp-columns-desktop", String(isNaN(columns) ? 4 : columns));

    const isMobile = () => window.matchMedia("(max-width: 989px)").matches;

    const getMaxScrollLeft = () => (tabsEl.scrollWidth - tabsEl.clientWidth);

    const updateNavState = () => {

      const maxScrollLeft = getMaxScrollLeft();
      const left = tabsEl.scrollLeft || 0;

      const canLeft = left > 2;
      const canRight = left < maxScrollLeft - 2;

      root.setAttribute("data-can-scroll-left", canLeft ? "true" : "false");
      root.setAttribute("data-can-scroll-right", canRight ? "true" : "false");

      if (btnPrev) btnPrev.disabled = !canLeft;
      if (btnNext) btnNext.disabled = !canRight;

      if (!tabsWrap) return;
    };

    const safeScrollTabIntoView = (tabEl) => {
      if (!tabEl) return;

      try {
        tabEl.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center"
        });
      } catch (e) {
        try { tabEl.scrollIntoView(true); } catch (e2) {}
      }
    };

    const getActiveIndex = () => {
      const idx = tabs.findIndex((t) => t.getAttribute("aria-selected") === "true");
      return idx >= 0 ? idx : 0;
    };

    const activateByIndex = (idx, direction = "next") => {

      if (idx < 0 || idx >= tabs.length) return;

      const tab = tabs[idx];
      const panelId = tab.getAttribute("data-tnp-tab");

      if (!panelId) return;

      activate(panelId, tab, direction);
    };


    /* ----------------------------------
       PANEL ANIMATION
    ---------------------------------- */

    const activate = (panelId, clickedTabEl, direction = "next", shouldScrollTab = true) => {
    const leavingClass = direction === "prev" ? "is-leaving-right" : "is-leaving-left";
    const enteringClass = direction === "prev" ? "is-entering-left" : "is-entering-right";

    const currentPanel = panels.find((p) => !p.hasAttribute("hidden"));
    const nextPanel = panels.find((p) => p.id === panelId);

    // Update tab selected state
    tabs.forEach((t) => {
        const isActive = t.getAttribute("data-tnp-tab") === panelId;
        t.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    if (!nextPanel || currentPanel === nextPanel) {
        panels.forEach((p) => {
        const isActive = p.id === panelId;
        if (isActive) p.removeAttribute("hidden");
        else p.setAttribute("hidden", "");
        });
        if (shouldScrollTab) safeScrollTabIntoView(clickedTabEl);
        updateNavState();
        return;
    }

    // 1) Show next panel and set initial entering state
    nextPanel.removeAttribute("hidden");
    nextPanel.classList.add(enteringClass);

    // 2) Make sure both panels are "displayed" during animation
    // (currentPanel is already visible)
    if (currentPanel) currentPanel.classList.add(leavingClass);

    // 3) Trigger transition: remove enteringClass on next frame
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
        nextPanel.classList.remove(enteringClass);
        });
    });

    // 4) Cleanup after transition
    const cleanup = () => {
        if (currentPanel) {
        currentPanel.setAttribute("hidden", "");
        currentPanel.classList.remove(leavingClass);
        }
        updateNavState();
    };

    // Wait for transition end OR fallback timeout
    const DURATION = 250;
    let done = false;

    const onEnd = (e) => {
        if (done) return;
        done = true;
        nextPanel.removeEventListener("transitionend", onEnd);
        cleanup();
    };

    nextPanel.addEventListener("transitionend", onEnd, { once: true });
    setTimeout(onEnd, DURATION);

    if (shouldScrollTab) safeScrollTabIntoView(clickedTabEl);
    };    


    /* ----------------------------------
       TAB CLICK
    ---------------------------------- */

    tabsEl.addEventListener("click", (e) => {

      const btn = e.target.closest(".tnp-tab");

      if (!btn) return;

      const panelId = btn.getAttribute("data-tnp-tab");

      if (!panelId) return;

      const from = getActiveIndex();

      const to = tabs.findIndex(
        t => t.getAttribute("data-tnp-tab") === panelId
      );

      const direction = to < from ? "prev" : "next";

      activate(panelId, btn, direction);

    });


    /* ----------------------------------
       TAB SCROLL BUTTON
    ---------------------------------- */

    const scrollByAmount = () =>
      Math.max(120, Math.floor(tabsEl.clientWidth * 0.8));

    const scrollTabs = (dir) => {

      const amount = scrollByAmount() * dir;

      try {

        tabsEl.scrollBy({
          left: amount,
          behavior: "smooth"
        });

      } catch (e) {

        tabsEl.scrollLeft =
          (tabsEl.scrollLeft || 0) + amount;

      }

      setTimeout(updateNavState, 150);
    };

    if (btnPrev)
      btnPrev.addEventListener("click", () => scrollTabs(-1));

    if (btnNext)
      btnNext.addEventListener("click", () => scrollTabs(1));

    tabsEl.addEventListener("scroll", updateNavState);

    window.addEventListener("resize", updateNavState);


    /* ----------------------------------
       MOBILE SWIPE
    ---------------------------------- */

    const attachSwipe = (el) => {

      let startX = 0;
      let startY = 0;

      let dx = 0;
      let dy = 0;

      let tracking = false;

      const onStart = (x, y) => {

        tracking = true;

        startX = x;
        startY = y;

        dx = 0;
        dy = 0;
      };

      const onMove = (x, y) => {

        if (!tracking) return;

        dx = x - startX;
        dy = y - startY;
      };

      const onEnd = () => {

        if (!tracking) return;

        tracking = false;

        if (!isMobile()) return;

        const absX = Math.abs(dx);
        const absY = Math.abs(dy);

        if (absY > absX) return;

        const THRESHOLD = 50;

        if (absX < THRESHOLD) return;

        const activeIndex = getActiveIndex();

        if (dx < 0)
          activateByIndex(activeIndex + 1, "next");
        else
          activateByIndex(activeIndex - 1, "prev");
      };

      el.addEventListener("touchstart", (e) => {

        const t = e.touches[0];

        if (!t) return;

        onStart(t.clientX, t.clientY);

      }, { passive: true });

      el.addEventListener("touchmove", (e) => {

        const t = e.touches[0];

        if (!t) return;

        onMove(t.clientX, t.clientY);

      }, { passive: true });

      el.addEventListener("touchend", onEnd);

      el.addEventListener("pointerdown", (e) =>
        onStart(e.clientX, e.clientY)
      );

      el.addEventListener("pointermove", (e) =>
        onMove(e.clientX, e.clientY)
      );

      el.addEventListener("pointerup", onEnd);

      el.addEventListener("pointercancel", onEnd);
    };


    const swipeTargets =
      root.querySelectorAll(".tnp-panel.tnp-swipe");

    if (swipeTargets.length) {

      swipeTargets.forEach((p) => attachSwipe(p));

    } else {

      panels.forEach((p) => attachSwipe(p));

    }


    /* ----------------------------------
       INIT
    ---------------------------------- */

    const first = tabs[0];

    if (first) {

      const firstPanelId =
        first.getAttribute("data-tnp-tab");

      if (firstPanelId)
        activate(firstPanelId, first, "next", false);

    } else {

      updateNavState();

    }

  });
});